import { render } from "./MailingListManagerEditorCmp.vue?vue&type=template&id=194fc2d6"
import script from "./MailingListManagerEditorCmp.vue?vue&type=script&lang=js"
export * from "./MailingListManagerEditorCmp.vue?vue&type=script&lang=js"

import "./MailingListManagerEditorCmp.vue?vue&type=style&index=0&id=194fc2d6&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__